/**
 * @author alteredq / http://alteredqualia.com/
 *
 * Full-screen textured quad shader
 */
import * as THREE from "../../../../libs/three.js/build/three.module.js";




let CopyShader = {

	uniforms: {

		"tDiffuse": { value: null },
		"opacity":  { value: 1.0 }

	},

	vertexShader: [

		"varying vec2 vUv;",

		"void main() {",

			"vUv = uv;",
			"gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",

		"}"

	].join( "\n" ),

	fragmentShader: [

		"uniform float opacity;",

		"uniform sampler2D tDiffuse;",

		"varying vec2 vUv;",

		"void main() {",

			"vec4 texel = texture2D( tDiffuse, vUv );",     //如果开启premultipliedAlpha用这个，否则用注释的
			"gl_FragColor = opacity * texel;",
            
            //"gl_FragColor = texture2D( tDiffuse, vUv );", 
			//"gl_FragColor.a *= opacity;",

		"}"

	].join( "\n" )

};
export default CopyShader